"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _parameterManage = require("@/api/_homeCloudPlatform/parameter/parameterManage.js");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _Editor = _interopRequireDefault(require("@/components/Editor"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var formModel = {};

// const phoneValidator = (rule, value, callBack) => {
//   const reg = /^[1][0-9]{10}$/
//   if (value) {
//     if (!reg.test(value)) {
//       callBack('请输入正确的联络人手机号')
//     } else {
//       callBack()
//     }
//   } else {
//     callBack()
//   }
// }
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default,
    Editor: _Editor.default
  },
  computed: {
    rules: function rules() {
      var _this = this;
      return {
        system_configurations_name: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }, {
          max: 64,
          message: '输入长度不能超过64位'
        }],
        value: [{
          required: true,
          message: '请输入内容',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callBack) {
            if (_this.htmlType.filter(function (item) {
              return item === _this.formModel.system_configurations_type;
            }).length > 0) {
              if (document.querySelector('.ql-editor').innerText.trim().length === 0) {
                callBack('请输入内容');
              } else {
                callBack();
              }
            }
            callBack();
          },
          trigger: 'change'
        }]
      };
    },
    dialogTitle: function dialogTitle() {
      var type = '';
      switch (this.dialogType) {
        case 'view':
          type = '检视';
          break;
        case 'add':
          type = '新增';
          break;
        case 'edit':
          type = '编辑';
          break;
      }
      return "".concat(type, "\u53C2\u6570");
    }
  },
  watch: {
    dialogType: {
      immediate: true,
      handler: function handler(val) {
        this.disabled = val !== 'edit' && val !== 'add';
      }
    }
  },
  data: function data() {
    return {
      formModel: formModel,
      disabled: false,
      tableData: {},
      listLoading: true,
      // 預設排序,依創建時間遞減
      defaultOrdering: '-created_at',
      listQuery: {
        page: 1,
        page_size: 20,
        page_size_before: 20
      },
      dialogVisible: false,
      dialogType: 'view',
      htmlType: [1]
    };
  },
  created: function created() {
    this.handleSort();
    this.getList();
  },
  methods: {
    checkPermission: _permission.default,
    getList: function getList(e) {
      var _this2 = this;
      this.listLoading = true;
      if (e && this.listQuery.page_size_before != e.limit) {
        this.listQuery.page = 1;
        this.listQuery.page_size_before = e.limit;
      }
      (0, _parameterManage.getSystemConfigurationsList)(this.listQuery).then(function (res) {
        _this2.tableData = res || {};
        _this2.listLoading = false;
      });
    },
    handleView: function handleView(scope) {
      var _this3 = this;
      this.formModel = JSON.parse(JSON.stringify(scope.row));
      this.dialogType = 'view';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this3.$refs['Form'].clearValidate();
      });
    },
    handleEdit: function handleEdit(scope) {
      var _this4 = this;
      this.formModel = JSON.parse(JSON.stringify(scope.row));
      this.dialogType = 'edit';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this4.$refs['Form'].clearValidate();
      });
    },
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(form) {
        var _this5 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  var isEdit = _this5.dialogType === 'edit';
                  if (isEdit) {
                    (0, _parameterManage.patchSystemConfigurations)(_this5.formModel.id, _this5.handleFormData()).then(function (res) {
                      if (res.status_code !== 200) {
                        return _this5.errorHandle(res);
                      }
                      _this5.getList();
                      _this5.dialogVisible = false;
                      _this5.$message({
                        message: "\u7F16\u8F91\u6210\u529F",
                        type: 'success'
                      });
                    });
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function confirm(_x) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }(),
    handleFormData: function handleFormData() {
      var _this6 = this;
      for (var key in this.formModel) {
        switch (key) {
          case 'value':
            if (this.htmlType.filter(function (item) {
              return item === _this6.formModel.system_configurations_type;
            }).length > 0) this.formModel[key] = this.$refs.editor.handlehtml(this.formModel[key]);
            break;
        }
      }
      return {
        name: this.formModel.system_configurations_name,
        value: this.formModel.value
      };
    },
    handleSort: function handleSort(column) {
      // 初始化處理
      if (!column) {
        this.listQuery.ordering = this.listQuery.ordering || this.defaultOrdering;
        return {
          prop: this.defaultOrdering.indexOf('-') !== -1 ? this.defaultOrdering.split('-')[1] : this.defaultOrdering,
          order: this.defaultOrdering.indexOf('-') !== -1 ? 'descending' : 'ascending'
        };
      }
      // 點擊排序
      else {
        this.listQuery.ordering = column.order ? "".concat(column.order === 'descending' ? '-' : '').concat(column.prop) : this.defaultOrdering;
        this.getList();
      }
    }
  }
};